import gql from 'graphql-tag'

export const ADD_TEMPO_ORDER = gql`
 mutation insert_tempoOrders($id: uuid!,$tempoOrderCode: String!,$contractorId: uuid!,$contractorCode: String!,
 $tempoId: uuid!,$driverId: uuid!, $date: date!, $startReading: String!, $endReading: String!, $city: String!, $createdAt: timestamptz!) {
  insert_tempoOrders(objects: {id: $id, tempoOrderCode: $tempoOrderCode, contractorId: $contractorId, contractorCode: $contractorCode,
   tempoId: $tempoId, driverId: $driverId, date: $date, startReading: $startReading, endReading: $endReading, city: $city, createdAt: $createdAt}) {
    returning {
      id
 }
}
  }
`
export const UPDATE_TEMPO_ORDER = gql`
 mutation ($tempoOrderId: uuid!, $contractorId: uuid!, $contractorCode: String!,$tempoId: uuid!,$driverId: uuid!,
 $startReading: String!, $endReading: String!, $city: String!, $date: date!) {
   update_tempoOrders (where: {id: {_eq: $tempoOrderId}}, _set: {contractorId: $contractorId, contractorCode: $contractorCode,
   tempoId: $tempoId, driverId: $driverId, startReading: $startReading, endReading: $endReading, city: $city, date: $date}) {
    returning {
      id
     }
    }
  }
`
export const UPDATE_TEMPOORDER_ENDREADING = gql`
 mutation ($tempoOrderId: uuid!, $endReading: String!) {
   update_tempoOrders (where: {id: {_eq: $tempoOrderId}}, _set: {endReading: $endReading}) {
    returning {
      id
     }
    }
  }
`
export const DELETE_TEMPO_ORDER = gql`
 mutation ($tempoOrderId: uuid!) {
   delete_tempoOrders(where: {id: {_eq: $tempoOrderId}}) {
    returning {
      id
     }
    }
  }
`
